import { GrowthBook, GrowthBookProvider, configureCache } from "@growthbook/growthbook-react";
import jwt_decode from "jwt-decode";
import { FC, PropsWithChildren, useEffect, useMemo, useState } from "react";



import isValidTokenAccess from "web/utils/system/essentials/isValidTokenAccess";
import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";
import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";



import storageNames from "web/constants/storageNames";



import growthBookConfig from "web/context/growthBookConfig";


const storage = new BrowserPersistence();

const GrowthBookFF: FC<PropsWithChildren> = ({ children }) => {
  const gb = useMemo(() => {
    return new GrowthBook(growthBookConfig);
  }, []);

  const [isInitialized, setIsInitialized] = useState(false);
  const [tokenVersion, setTokenVersion] = useState(0);

  useEffect(() => {
    const handleTokenChange = () => {
      setTokenVersion((v) => v + 1);
    };

    window.addEventListener('tokenChange', handleTokenChange);

    return () => {
      window.removeEventListener('tokenChange', handleTokenChange);
    };
  }, []);

  useEffect(() => {
    if (!isInitialized) {
      (async () => {
        try {
          await gb.init({ streaming: true });
          configureCache({ disableCache: true });
          setIsInitialized(true);
        } catch (error) {
          newRelicErrorReport(
            error,
            "web-app/web/context/GrowthBookFF.tsx - gb.init"
          );
          console.error("Failed to initialize GrowthBook:", error);
        }
      })();
    }
  }, [gb, isInitialized]);

  useEffect(() => {
    if (!isInitialized) return;

    try {
      const authenticated = isValidTokenAccess();
      const accessToken = storage.getItem(storageNames.tokenAccess);

      if (authenticated && accessToken) {
        const { MyB_SSO_UID, companyId, realm_access } = jwt_decode<{
          MyB_SSO_UID: string;
          companyId: string;
          realm_access: { roles: string[] };
        }>(accessToken);

        const hasHrToolsEarlyAccess = realm_access.roles.includes(
          "HR_TOOLS_EARLY_ACCESS"
        );

        const attributes = {
          companyId,
          employeeId: MyB_SSO_UID,
          hasHrToolsEarlyAccess,
        };

        gb.updateAttributes(attributes);
      }
    } catch (error) {
      newRelicErrorReport(
        error,
        "web-app/web/context/GrowthBookFF.tsx - update.setAttributes"
      );
      console.error("Failed to update GrowthBook attributes:", error);
    }
  }, [gb, isInitialized, tokenVersion]);

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
};

export default GrowthBookFF;
